/**
 * VISP平台相关的常量
 */

/**
 * 所有组织的ID
 */
const ALL_ORG_ID = 0;

/**
 * 单个服务对象的最小服务费下限,默认755
 */
const TARGET_MIN_SERVICE_AMOUNT = 755;

/**
 * 单个服务对象的最大服务费上限,默认800
 */
const TARGET_MAX_SERVICE_AMOUNT = 800;

export {
    ALL_ORG_ID,
    TARGET_MIN_SERVICE_AMOUNT,
    TARGET_MAX_SERVICE_AMOUNT
};